import React, { Component } from "react";
import ActionButton from "./actionButton";
import TitleBar from "../titleBar/title_bar";
import { AgGridReact } from "ag-grid-react";
import { AllModules } from "ag-grid-enterprise";
import { Header, Segment } from "semantic-ui-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-enterprise";
import { LicenseManager } from "ag-grid-enterprise";
import LoadingPlaceholder from "../placeholderComponent/loadingPlaceholder";
import CustomNoRowsOverlay from "./customNoRowsOverlay.js";
import { translate } from "react-i18next";
import GenerateOrderButton from './generateorder';
import AddVehicleToVehicleAvailability from '../../views/masters/vehicleAvailability/addVehicleToVehicleAvailability';
import { NO_RECORDS_FOUND } from "../../utils/validationConstant";

LicenseManager.setLicenseKey(
  "Elixia_Tech_Solutions_Ltd_MultiApp_1Devs16_March_2019__MTU1MjY5NDQwMDAwMA==c4c29e5702e62789dbdb799433c73545"
);

class AgGridTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modules: AllModules,
      defaultColDef: {
        flex: 1,
        minWidth: 100,
        statusLoading: false,
        enableValue: true,
        resizable: true,
        enableRowGroup: true,
        enablePivot: true,
      },
      sideBar: {
        toolPanels: [
          {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel",
          },
          {
            id: "filters",
            labelDefault: "Filters",
            labelKey: "filters",
            iconKey: "filter",
            toolPanel: "agFiltersToolPanel",
          },
        ],
        defaultToolPanel: "",
      },
      isLoading: true,
      rowData: [],
      searchValue: "",
      // ag grid custom overlay
      frameworkComponents: {
        actionRenderer: ActionButton,
        generateorder: GenerateOrderButton,
        customNoRowsOverlay: CustomNoRowsOverlay,
        ...this.props.extraComponents
      },
      noRowsOverlayComponent: "customNoRowsOverlay",
      noRowsOverlayComponentParams: {
        noRowsMessageFunc: function () {
          return NO_RECORDS_FOUND;
        },
      },
      exportLoading : false
    };
  }

  componentDidMount() {
    this.setState({ statusLoading: true })
    setTimeout(() => {
      this.setState({ statusLoading: false })
    }, 2000);
  }

  handleChange = (e) => {
    if(this.props.hasOwnProperty('customSearch')){
      this.props.customSearch(e.target.value)
    } else {
      this.setState({ searchValue: e.target.value });
    }
  };

  getParams() {
    return {
      columnGroups: true,
      fileName: this.props.titleBarTitle,
    };
  }

  onBtnExportDataAsExcel = () => {
    var params = this.getParams();
    this.gridApi.exportDataAsExcel(params);
    
  };

  onGridReady = (params) => {
    this.gridApi = params.api;

    this.setState({
      isLoading: this.props.isLoading,
    });


    this.gridColumnApi = params.columnApi;

    //AutoSize Columns OnGridReady
    var allColumnIds = [];

    this.gridColumnApi.getAllColumns().forEach(function (column) {
      allColumnIds.push(column.colId);
    });

    this.gridColumnApi.autoSizeColumns(allColumnIds);
  };

  importDataGrid = () => {
    //console.log("import the data grid");
  };

   exportDataGrid = async () => {
     if (this.props.exporDatatFunction){
      this.setState({exportLoading : true})
       this.props.exporDatatFunction(this.props.columnDefs, this.cancelExportLoading);
       return;
     }
     let keys = [];
     await this.props.columnDefs.forEach((element) => {
       element.field !== "edit" && keys.push(element.field);
      });
    // console.log(keys);
    let param = {
      fileName: this.props.titleBarTitle,
      columnKeys:keys
    };
  this.gridApi.exportDataAsExcel(param);

  };

  filterChanged = (e) => {
    if (this.gridApi.getDisplayedRowCount() === 0) {
      this.gridApi.showNoRowsOverlay();
    } else {
      this.gridApi.hideOverlay();
    }
  };

  autoSizeAll = (skipHeader) => {
    var allColumnIds = [];
    this.gridColumnApi.getAllColumns().forEach(function (column) {
      allColumnIds.push(column.colId);
    });
    this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
  };

  setExportLoading = () => {this.setState({exportLoading : true})}
  cancelExportLoading = () => {this.setState({exportLoading : false})}

  render() {
    const { frameworkComponents } = this.state;
    const { t } = this.props;
    // if (this.props.isLoading === true) {
    //   return (
    //     <React.Fragment>
    //       <TitleBar
    //         title={this.props.titleBarTitle}
    //         LinkName={this.props.titleBarLink}
    //         importDataGrid={this.importDataGrid}
    //         exportDataGrid={this.exportDataGrid}
    //       />
    //       <LoadingPlaceholder />
    //     </React.Fragment>
    //   );
    // } else if (!this.props.rowData || this.props.rowData.length === 0) {
    //   return (
    //     <React.Fragment>
    //       <TitleBar
    //         title={this.props.titleBarTitle}
    //         LinkName={this.props.titleBarLink}
    //         importDataGrid={this.importDataGrid}
    //         exportDataGrid={this.exportDataGrid}
    //       />
    //       <Segment className="m-2">
    //         <center>
    //           {" "}
    //           <Header>{t("no_records_found") || "NO Record(s) Found"}</Header>
    //         </center>
    //       </Segment>
    //     </React.Fragment>
    //   );
    // } else {
    return (
      <>
        {!this.props.hide ?
          <>
            <TitleBar
              title={this.props.titleBarTitle}
              LinkName={this.props.titleBarLink}
              handleSearch={this.handleChange}
              importDataGrid={this.importDataGrid}
              exportDataGrid={this.exportDataGrid}
              exportHidden={this.props.exportHidden}
              radioToggle={this.props.radioToggle}
              toggleView={this.props.toggleView}
              toggle={this.props.toggle}
              baseURL={this.props.baseURL}
              pathName={this.props.pathName}
              propsFromChild={this.props.propsFromChild}
              moduleName = {this.props.moduleName}
              hideFilter = {this.props.hideFilter||false}
              hideTitleBarTools = {this.props.hideTitleBarTools || false}
              hideNew={this.props.hideNew}
              exportLoading={this.state.exportLoading}
              importHidden={this.props.importHidden}
            />
            {this.props.reportsFilter}
          </>
          : ""}
        {
          this.props.addVehicleToVehicleAvailability ?
            <AddVehicleToVehicleAvailability></AddVehicleToVehicleAvailability>
            : null
        }
        {this.state.statusLoading == true || this.props.isLoading == true ? (
          <LoadingPlaceholder />
        ) : (
          <>
            <div className="ag-theme-material agOver">
              <AgGridReact
                domLayout="autoHeight"
                modules={this.state.modules}
                debounceVerticalScrollbar={true}
                sideBar={this.state.sideBar}
                rowGroupPanelShow={"always"}
                quickFilterText={this.state.searchValue}
                // suppressAutoSize={true}
                columnDefs={this.props.columnDefs}
                defaultColDef={this.state.defaultColDef}
                frameworkComponents={frameworkComponents}
                rowSelection="multiple"
                rowData={this.props.rowData}
                onCellDoubleClicked={this.props.cellDoubleClicked}
                pagination={this.props.pagination || true}
                loadingOverlayComponent={this.state.isLoading}
                paginationPageSize={15}
                onGridReady={this.onGridReady}
                baseURL={this.props.baseURL}
                completeURL={this.props.completeURL}
                deleteURL={this.props.deleteURL}
                keyIndex={this.props.keyIndex}
                onEdit={this.props.onEdit}
                onDelete={this.props.onDelete}
                hideRowEdit={this.props.hideRowEdit}
                hideRowDelete={this.props.hideRowDelete}
                noRowsOverlayComponent={this.state.noRowsOverlayComponent}
                noRowsOverlayComponentParams={
                  this.state.noRowsOverlayComponentParams
                }
                onFilterChanged={this.filterChanged}
                {...this.props}
              />
            </div>
          </>)}
      </>
    );
    //   }
  }
}

export default translate("ag_grid")(AgGridTable);
